import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f63ef3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "tList" }
const _hoisted_2 = { style: {"background-color":"white"} }
const _hoisted_3 = { "aria-hidden": "true" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Click to view Help Videos", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_neu_drawer_button = _resolveComponent("neu-drawer-button")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_item = _resolveComponent("neu-item")!
  const _component_neu_list = _resolveComponent("neu-list")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_neu_avatar = _resolveComponent("neu-avatar")!
  const _component_neu_link = _resolveComponent("neu-link")!
  const _component_neu_user_controls = _resolveComponent("neu-user-controls")!
  const _component_neu_toolbar = _resolveComponent("neu-toolbar")!
  const _component_neu_header = _resolveComponent("neu-header")!
  const _component_neu_drawer_toggle = _resolveComponent("neu-drawer-toggle")!
  const _component_neu_content = _resolveComponent("neu-content")!
  const _component_neu_drawer = _resolveComponent("neu-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_neu_header, null, {
      default: _withCtx(() => [
        (_ctx.oidcUser)
          ? (_openBlock(), _createBlock(_component_neu_toolbar, {
              key: 0,
              nav: "",
              fluid: "",
              color: "primary-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_drawer_button, {
                  slot: "start",
                  text: "Menu",
                  class: "d-md-none",
                  drawer: "first"
                }),
                _createVNode(_component_neu_row, {
                  noGutters: "",
                  slot: "secondary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_tablist, { class: "d-none d-md-block" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                          return (_openBlock(), _createBlock(_component_neu_tab, {
                            key: page.path,
                            class: _normalizeClass(_ctx.selectedPage === page.path ? 'neu-tab--navy-active' : ''),
                            navy: "",
                            onClick: ($event: any) => (_ctx.routeToPage(page.path))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(page.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_row, { slot: "end" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      (_ctx.isTrainingVideoListVisible)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onMouseleave: _cache[0] || (_cache[0] = ($event: any) => {_ctx.isTrainingVideoListVisible=false;}),
                            class: "modalTutorialList z-max",
                            id: "trainingVideoList",
                            style: {"border":"solid","border-color":"#3673AA"}
                          }, [
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_neu_list, {
                                color: "white",
                                lines: "none",
                                style: {"background-color":"white"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTrainingVideoList, (item) => {
                                    return (_openBlock(), _createBlock(_component_neu_item, {
                                      key: item.name,
                                      class: "training-video-list"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_neu_label, {
                                          onClick: ($event: any) => (_ctx.openVideo(item.path))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ])
                          ], 32))
                        : _createCommentVNode("", true),
                      (_ctx.profileData.TrainingEnabled)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "#",
                            class: "modaltoolbarIcon neu-tooltip",
                            style: {"cursor":"pointer","color":"white","top":"10px"},
                            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.displayTrainingList($event);})
                          }, [
                            _createElementVNode("span", _hoisted_3, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'fa-video'],
                                size: "lg"
                              }),
                              _createTextVNode(" Tutorials ")
                            ]),
                            _hoisted_4
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode("   ")
                    ]),
                    _createTextVNode("   "),
                    (_ctx.tenants.length > 1)
                      ? (_openBlock(), _createBlock(_component_VueMultiselect, {
                          key: 0,
                          style: {"width":"9.375rem","margin-right":"0.5rem","order":"1"},
                          class: "tenantslist",
                          name: "tenantsSelection",
                          id: "tenantsSelection",
                          modelValue: _ctx.selectedTenant,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTenant) = $event)),
                            _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTenantDataToSession($event)))
                          ],
                          options: _ctx.tenants,
                          multiple: false,
                          searchable: true,
                          "close-on-select": true,
                          placeholder: "Select Tenant",
                          "track-by": "text",
                          label: "text"
                        }, null, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_neu_user_controls, {
                      style: {"order":"2"},
                      class: "d-none d-md-flex",
                      user: 
            _ctx.oidcUser.firstName.toUpperCase() +
            ' ' +
            _ctx.oidcUser.lastName.toUpperCase()
          
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_neu_link, {
                          nav: "",
                          href: _ctx.appLogoutUrl
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_avatar, {
                              class: "icon-padding",
                              color: "plain-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("logout")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    }, 8, ["user"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.oidcUser)
      ? (_openBlock(), _createBlock(_component_neu_drawer, {
          key: 0,
          side: "start",
          "drawer-id": "first",
          "content-id": "drawerContent"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_content, {
              id: "drawerContent",
              nav: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_list, {
                  lines: "full",
                  nav: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_drawer_toggle, {
                      "auto-hide": "",
                      drawer: "first"
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                      return (_openBlock(), _createBlock(_component_neu_item, {
                        key: page.path,
                        nav: "",
                        active: _ctx.selectedPage === page.path,
                        onClick: ($event: any) => (_ctx.routeToPage(page.path))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(page.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["active", "onClick"]))
                    }), 128)),
                    _createVNode(_component_neu_item, { nav: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_neu_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("logout")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_neu_link, {
                          nav: "",
                          href: _ctx.appLogoutUrl,
                          class: "neu-tab-h"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Logout ")
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}